import { render, staticRenderFns } from "./EditEntityContact.vue?vue&type=template&id=78960b93&"
import script from "./EditEntityContact.vue?vue&type=script&lang=js&"
export * from "./EditEntityContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports